import { render, staticRenderFns } from "./HomeworkIcon.vue?vue&type=template&id=3350c95d&scoped=true&"
import script from "./HomeworkIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HomeworkIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3350c95d",
  null
  
)

export default component.exports